// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-split-merge-dialog-container .heading {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 500;
}
.job-split-merge-dialog-container .company-name {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 200;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/job/dialogs/job-split-merge-dialog/job-split-merge-dialog.component.scss"],"names":[],"mappings":"AACC;EACC,iBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;AAGC;EACC,iBAAA;EACA,mBAAA;EACA,gBAAA;AADF","sourcesContent":[".job-split-merge-dialog-container {\n\t.heading {\n\t\tfont-size: 1.5rem;\n\t\tmargin-bottom: 1rem;\n\t\tfont-weight: 500;\n\t}\n\n\t.company-name {\n\t\tfont-size: 1.5rem;\n\t\tmargin-bottom: 1rem;\n\t\tfont-weight: 200;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
